// extracted by mini-css-extract-plugin
module.exports = {"root":"InsurgencyMap_root__1ogSm","tableDataOuter":"InsurgencyMap_tableDataOuter__1eRZ1","scrollbar":"InsurgencyMap_scrollbar__10Ujo","thumb":"InsurgencyMap_thumb__1FNge"};